// Shared without importing the API client into the synchronous logout path.
export const nativeInstallationSession = { current: null };

export function invalidateIOSInstallationAssociation() {
  nativeInstallationSession.current?.invalidate();
}
